export const parishes = [
  'Christ Church',
  'St. Andrew',
  'St. George',
  'St. James',
  'St. John',
  'St. Joseph',
  'St. Lucy',
  'St. Michael',
  'St. Peter',
  'St. Phillip',
  'St. Thomas',
];
export const clubs = [
  'BAMSAC',
  'BC Trac',
  'BDF Sports Program',
  'Black Birds Track and Field',
  'Elite Distance',
  'Freedom Striders Track &amp; Field Club',
  'Full Flyt Athletics',
  'High Performance Programme',
  'Not Attached',
  'Pacers Track Club',
  'Pegasus Training Programme',
  'Proformers Track and Field Club',
  'Quantum Leap Programme',
  'Rising Stars Track &amp; Field Club',
  'Talons Track &amp; Field Barbados',
  'UFUKUZO Road Racing Club',
  'United Athletic Club',
  'Velocity Management Track &amp; Field Club',
  'Wibisco Stars Athletic Club',
];
export const countries = [
  'Afghanistan',
  'Åland Islands',
  'Albania',
  'Algeria',
  'American Samoa',
  'Andorra',
  'Angola',
  'Anguilla',
  'Antarctica',
  'Antigua and Barbuda',
  'Argentina',
  'Armenia',
  'Aruba',
  'Australia',
  'Austria',
  'Azerbaijan',
  'Bahamas',
  'Bahrain',
  'Bangladesh',
  'Barbados',
  'Belarus',
  'Belgium',
  'Belize',
  'Benin',
  'Bermuda',
  'Bhutan',
  'Bolivia (Plurinational State of)',
  'Bonaire, Sint Eustatius and Saba',
  'Bosnia and Herzegovina',
  'Botswana',
  'Bouvet Island',
  'Brazil',
  'British Indian Ocean Territory',
  'United States Minor Outlying Islands',
  'Virgin Islands (British)',
  'Virgin Islands (U.S.)',
  'Brunei Darussalam',
  'Bulgaria',
  'Burkina Faso',
  'Burundi',
  'Cambodia',
  'Cameroon',
  'Canada',
  'Cabo Verde',
  'Cayman Islands',
  'Central African Republic',
  'Chad',
  'Chile',
  'China',
  'Christmas Island',
  'Cocos (Keeling) Islands',
  'Colombia',
  'Comoros',
  'Congo',
  'Congo (Democratic Republic of the)',
  'Cook Islands',
  'Costa Rica',
  'Croatia',
  'Cuba',
  'Curaçao',
  'Cyprus',
  'Czech Republic',
  'Denmark',
  'Djibouti',
  'Dominica',
  'Dominican Republic',
  'Ecuador',
  'Egypt',
  'El Salvador',
  'Equatorial Guinea',
  'Eritrea',
  'Estonia',
  'Ethiopia',
  'Falkland Islands (Malvinas)',
  'Faroe Islands',
  'Fiji',
  'Finland',
  'France',
  'French Guiana',
  'French Polynesia',
  'French Southern Territories',
  'Gabon',
  'Gambia',
  'Georgia',
  'Germany',
  'Ghana',
  'Gibraltar',
  'Greece',
  'Greenland',
  'Grenada',
  'Guadeloupe',
  'Guam',
  'Guatemala',
  'Guernsey',
  'Guinea',
  'Guinea-Bissau',
  'Guyana',
  'Haiti',
  'Heard Island and McDonald Islands',
  'Holy See',
  'Honduras',
  'Hong Kong',
  'Hungary',
  'Iceland',
  'India',
  'Indonesia',
  "Côte d'Ivoire",
  'Iran (Islamic Republic of)',
  'Iraq',
  'Ireland',
  'Isle of Man',
  'Israel',
  'Italy',
  'Jamaica',
  'Japan',
  'Jersey',
  'Jordan',
  'Kazakhstan',
  'Kenya',
  'Kiribati',
  'Kuwait',
  'Kyrgyzstan',
  "Lao People's Democratic Republic",
  'Latvia',
  'Lebanon',
  'Lesotho',
  'Liberia',
  'Libya',
  'Liechtenstein',
  'Lithuania',
  'Luxembourg',
  'Macao',
  'Macedonia (the former Yugoslav Republic of)',
  'Madagascar',
  'Malawi',
  'Malaysia',
  'Maldives',
  'Mali',
  'Malta',
  'Marshall Islands',
  'Martinique',
  'Mauritania',
  'Mauritius',
  'Mayotte',
  'Mexico',
  'Micronesia (Federated States of)',
  'Moldova (Republic of)',
  'Monaco',
  'Mongolia',
  'Montenegro',
  'Montserrat',
  'Morocco',
  'Mozambique',
  'Myanmar',
  'Namibia',
  'Nauru',
  'Nepal',
  'Netherlands',
  'New Caledonia',
  'New Zealand',
  'Nicaragua',
  'Niger',
  'Nigeria',
  'Niue',
  'Norfolk Island',
  "Korea (Democratic People's Republic of)",
  'Northern Mariana Islands',
  'Norway',
  'Oman',
  'Pakistan',
  'Palau',
  'Palestine, State of',
  'Panama',
  'Papua New Guinea',
  'Paraguay',
  'Peru',
  'Philippines',
  'Pitcairn',
  'Poland',
  'Portugal',
  'Puerto Rico',
  'Qatar',
  'Republic of Kosovo',
  'Réunion',
  'Romania',
  'Russian Federation',
  'Rwanda',
  'Saint Barthélemy',
  'Saint Helena, Ascension and Tristan da Cunha',
  'Saint Kitts and Nevis',
  'Saint Lucia',
  'Saint Martin (French part)',
  'Saint Pierre and Miquelon',
  'Saint Vincent and the Grenadines',
  'Samoa',
  'San Marino',
  'Sao Tome and Principe',
  'Saudi Arabia',
  'Senegal',
  'Serbia',
  'Seychelles',
  'Sierra Leone',
  'Singapore',
  'Sint Maarten (Dutch part)',
  'Slovakia',
  'Slovenia',
  'Solomon Islands',
  'Somalia',
  'South Africa',
  'South Georgia and the South Sandwich Islands',
  'Korea (Republic of)',
  'South Sudan',
  'Spain',
  'Sri Lanka',
  'Sudan',
  'Suriname',
  'Svalbard and Jan Mayen',
  'Swaziland',
  'Sweden',
  'Switzerland',
  'Syrian Arab Republic',
  'Taiwan',
  'Tajikistan',
  'Tanzania, United Republic of',
  'Thailand',
  'Timor-Leste',
  'Togo',
  'Tokelau',
  'Tonga',
  'Trinidad and Tobago',
  'Tunisia',
  'Turkey',
  'Turkmenistan',
  'Turks and Caicos Islands',
  'Tuvalu',
  'Uganda',
  'Ukraine',
  'United Arab Emirates',
  'United Kingdom of Great Britain and Northern Ireland',
  'United States of America',
  'Uruguay',
  'Uzbekistan',
  'Vanuatu',
  'Venezuela (Bolivarian Republic of)',
  'Viet Nam',
  'Wallis and Futuna',
  'Western Sahara',
  'Yemen',
  'Zambia',
  'Zimbabwe',
];
export const nationalites = [
  'Afghan',
  'Ålandish',
  'Albanian',
  'Algerian',
  'American Samoan',
  'Andorran',
  'Angolan',
  'Anguillian',
  'Antiguan, Barbudan',
  'Argentinean',
  'Armenian',
  'Aruban',
  'Australian',
  'Austrian',
  'Azerbaijani',
  'Bahamian',
  'Bahraini',
  'Bangladeshi',
  'Barbadian',
  'Belarusian',
  'Belgian',
  'Belizean',
  'Beninese',
  'Bermudian',
  'Bhutanese',
  'Bolivian',
  'Dutch',
  'Bosnian, Herzegovinian',
  'Motswana',
  'Brazilian',
  'Indian',
  'American',
  'Virgin Islander',
  'Virgin Islander',
  'Bruneian',
  'Bulgarian',
  'Burkinabe',
  'Burundian',
  'Cambodian',
  'Cameroonian',
  'Canadian',
  'Cape Verdian',
  'Caymanian',
  'Central African',
  'Chadian',
  'Chilean',
  'Chinese',
  'Christmas Island',
  'Cocos Islander',
  'Colombian',
  'Comoran',
  'Congolese',
  'Congolese',
  'Cook Islander',
  'Costa Rican',
  'Croatian',
  'Cuban',
  'Dutch',
  'Cypriot',
  'Czech',
  'Danish',
  'Djibouti',
  'Dominican',
  'Dominican',
  'Ecuadorean',
  'Egyptian',
  'Salvadoran',
  'Equatorial Guinean',
  'Eritrean',
  'Estonian',
  'Ethiopian',
  'Falkland Islander',
  'Faroese',
  'Fijian',
  'Finnish',
  'French',
  'French Polynesian',
  'French',
  'Gabonese',
  'Gambian',
  'Georgian',
  'German',
  'Ghanaian',
  'Gibraltar',
  'Greek',
  'Greenlandic',
  'Grenadian',
  'Guadeloupian',
  'Guamanian',
  'Guatemalan',
  'Channel Islander',
  'Guinean',
  'Guinea-Bissauan',
  'Guyanese',
  'Haitian',
  'Heard and McDonald Islander',
  'Honduran',
  'Chinese',
  'Hungarian',
  'Icelander',
  'Indian',
  'Indonesian',
  'Ivorian',
  'Iranian',
  'Iraqi',
  'Irish',
  'Manx',
  'Israeli',
  'Italian',
  'Jamaican',
  'Japanese',
  'Channel Islander',
  'Jordanian',
  'Kazakhstani',
  'Kenyan',
  'I-Kiribati',
  'Kuwaiti',
  'Kirghiz',
  'Laotian',
  'Latvian',
  'Lebanese',
  'Mosotho',
  'Liberian',
  'Libyan',
  'Liechtensteiner',
  'Lithuanian',
  'Luxembourger',
  'Chinese',
  'Macedonian',
  'Malagasy',
  'Malawian',
  'Malaysian',
  'Maldivan',
  'Malian',
  'Maltese',
  'Marshallese',
  'French',
  'Mauritanian',
  'Mauritian',
  'French',
  'Mexican',
  'Micronesian',
  'Moldovan',
  'Monegasque',
  'Mongolian',
  'Montenegrin',
  'Montserratian',
  'Moroccan',
  'Mozambican',
  'Burmese',
  'Namibian',
  'Nauruan',
  'Nepalese',
  'Dutch',
  'New Caledonian',
  'New Zealander',
  'Nicaraguan',
  'Nigerien',
  'Nigerian',
  'Niuean',
  'Norfolk Islander',
  'North Korean',
  'American',
  'Norwegian',
  'Omani',
  'Pakistani',
  'Palauan',
  'Palestinian',
  'Panamanian',
  'Papua New Guinean',
  'Paraguayan',
  'Peruvian',
  'Filipino',
  'Pitcairn Islander',
  'Polish',
  'Portuguese',
  'Puerto Rican',
  'Qatari',
  'Kosovar',
  'French',
  'Romanian',
  'Russian',
  'Rwandan',
  'Saint Barthélemy Islander',
  'Saint Helenian',
  'Kittian and Nevisian',
  'Saint Lucian',
  'Saint Martin Islander',
  'French',
  'Saint Vincentian',
  'Samoan',
  'Sammarinese',
  'Sao Tomean',
  'Saudi Arabian',
  'Senegalese',
  'Serbian',
  'Seychellois',
  'Sierra Leonean',
  'Singaporean',
  'Dutch',
  'Slovak',
  'Slovene',
  'Solomon Islander',
  'Somali',
  'South African',
  'South Georgia and the South Sandwich Islander',
  'South Korean',
  'South Sudanese',
  'Spanish',
  'Sri Lankan',
  'Sudanese',
  'Surinamer',
  'Norwegian',
  'Swazi',
  'Swedish',
  'Swiss',
  'Syrian',
  'Taiwanese',
  'Tadzhik',
  'Tanzanian',
  'Thai',
  'East Timorese',
  'Togolese',
  'Tokelauan',
  'Tongan',
  'Trinidadian',
  'Tunisian',
  'Turkish',
  'Turkmen',
  'Turks and Caicos Islander',
  'Tuvaluan',
  'Ugandan',
  'Ukrainian',
  'Emirati',
  'British',
  'American',
  'Uruguayan',
  'Uzbekistani',
  'Ni-Vanuatu',
  'Venezuelan',
  'Vietnamese',
  'Wallis and Futuna Islander',
  'Sahrawi',
  'Yemeni',
  'Zambian',
  'Zimbabwean',
];
